<button
  class="selected-filter flex-center fw-400 lh-140"
  [ngClass]="{
    'filter-btn color-white': selectedFilterCount > 0,
    'clr-333 no-filter  bg-fff ': !selectedFilterCount
  }"
  (click)="filterBtnClicked()"
>
  <div class="icon-wrapper m-r-12">
    <span *ngIf="selectedFilterCount > 0" class="filters-count">{{
      selectedFilterCount
    }}</span>
    <img
      [ngClass]="{ 'white-filter-icon': selectedFilterCount > 0 }"
      [src]="images.FILTER_ICON"
      alt="filter icon"
    />
  </div>
  {{ 'MPOS_FILTERS.FILTER' | fallbackTranslate }}
</button>
